import { emptyMeasureState, pinPoint } from "../../measure/measureSession";
import type { BabylonState } from "../../state";

/**
 * Folds the pointer handler's queued clicks into the measure session, in
 * click order. Picking already happened at `pointerup`, so the queued
 * points are in data space.
 *
 * The queue is always cleared, but its points only become pins while the
 * measure tool is active; clicks recorded under a mode that has since
 * changed are discarded. The whole queue is applied at once, so a frame
 * that accumulated multiple clicks still completes the measurement.
 *
 * No-op for a state built without tool input.
 */
export function executeMeasurePin(state: BabylonState): void {
  const tool = state.input.tool;
  const pins = tool?.pendingPins;
  if (!tool || !pins || pins.length === 0) {
    return;
  }
  tool.pendingPins = undefined;
  if (tool.mode !== "measure") {
    return;
  }
  let measure = tool.measure ?? emptyMeasureState();
  for (const point of pins) {
    measure = pinPoint(measure, point);
  }
  tool.measure = measure;
}
